import * as d3 from 'd3';
import * as c3 from 'c3';
import Chart from 'src/javascripts/components/Chart';
import Spinner from 'src/javascripts/components/utilities/Spinner';
import SetColors from 'src/javascripts/components/charts/helpers/SetColors';
import RatingsChartTooltip from 'src/javascripts/components/charts/tooltips/RatingsChartTooltip';
import FormatString from 'src/javascripts/components/utilities/FormatString';

export default class Trend extends Chart {

  getData() {

    // Set chart element id
    const chartId = this.el.attr('id');

    // Set line color for render phase
    this.lineColor = this.el.attr('data-line-color') || '#00A9EB';

    // Set a spinner to indicate chart loading
    Spinner(this.el);

    // Get data from element if present
    let dataStr = this.el.attr('data-trend');
    let data = dataStr ? JSON.parse(dataStr) : undefined;
    if (typeof data !== 'undefined') { return data; }

    // Get data from url
    let url = this.el.attr('data-api-url');
    let params = {};
    return $.getJSON(url + '?' + $.param(params));

  }

  render(data) {

    // Set id
    let chartId = this.el.attr('id');
    let lineColor = this.lineColor || this.el.attr('data-line-color') || '#00A9EB';

    // If no data, replace chart with message
    if (data.data.length === 0) {
      $('#' + chartId).find('.spinner-container').remove();
      $('#' + chartId).append('<div>No data available yet</div>');
      return;
    }

    // Set as bar chart if only one datapoint
    let dataLen = data.data[0].length;
    let chartType;
    if (dataLen <= 2) {
      chartType = 'bar';
    } else {
      chartType = 'line';
    }

    // Render chart
    var chart = c3.generate({
      bindto: '#' + chartId,
      padding: {top: -10, bottom: -10, left: 20, right: 20},
      data: {
        x: 'date',
        columns: data.data,
        type: chartType,
        color: function () { return lineColor; }
      },
      point: {show: false},
      axis: {
        x: {
          show: true,
          type: 'timeseries',
          tick: {
            format: function (x) { return x.getMonth() + 1 + '-' + x.getDate() + '-' + x.getFullYear().toString().slice(-2); }
          }
        },
        y: {
          inner: true,
          show: false,
          padding: {bottom: 2},
          tick: {
            outer: false,
            format(v, id, i, j) { return v; }
          }
        }
      },
      bar: {width: 100},
      legend: {show: false},
      tooltip: {
        format: {},
        contents(d, defaultTitleFormat, defaultValueFormat, color) {
          return RatingsChartTooltip(chart, this, d, defaultTitleFormat, defaultValueFormat, 'Data', 2, color);
        }
      },
      grid: {
        y: {show: false},
        x: {show: false}
      }
    });

    // Set metrics
    let high = data.high;
    let low = data.low;
    let avg = data.avg;
    let change = data.change;
    let chartSum = $('#' + chartId).closest('.Card').find('.trendChartSummary');
    chartSum.find('.annual-high').empty().append(high);
    chartSum.find('.annual-low').empty().append(low);
    chartSum.find('.annual-avg').empty().append(avg);
    chartSum.find('.annual-change').empty().append(change);

    return chart;

  }


};
